import { colors } from './const';
import { resolveSurveyDevUrl } from './detect-framework';
import { runFillImplementationPlan } from './fill-implementation-plan';
import { printSurveyTypeInstallBlock } from './install-manifest';
import { resolveProjectRoot } from './resolve-project-root';
import { formatInput2BHandoffBlocks } from './workflow-prompts';
import { getErrorMessage } from '../types/shared';

const c = colors;

export interface SyncFromFetchOptions {
  projectRoot?: string;
  instanceIdOverride?: string;
}

/** INPUT 2 post-smoke: fill the implementation plan from the live fetch (§0, §3b–§3e). */
export async function runSyncFromFetch(options: SyncFromFetchOptions = {}): Promise<number> {
  const projectRoot = resolveProjectRoot(options.projectRoot);

  console.log(`${c.bold}=== CFM SDK — sync-from-fetch ===${c.reset}`);
  console.log(`${c.dim}Project: ${projectRoot}${c.reset}\n`);

  try {
    const { planPath, surveyTypes, hasMcqOtherPickers } = await runFillImplementationPlan({
      projectRoot,
      instanceIdOverride: options.instanceIdOverride,
    });
    console.log(`${c.green}✅ Patched ${planPath} from live fetch (§0, §3b–§3e)${c.reset}`);

    printSurveyTypeInstallBlock(projectRoot, surveyTypes, hasMcqOtherPickers);
    console.log(
      `${c.dim}Author a component for each fetched type — read its ui-spec first${c.reset}`,
    );
    const devUrl = resolveSurveyDevUrl(projectRoot);
    console.log(`\n${formatInput2BHandoffBlocks(devUrl)}\n`);
    console.log(`${c.dim}Next: npx cfm-sdk verify-build${c.reset}`);
    return 0;
  } catch (err: unknown) {
    console.error(`\n${c.red}❌ ${getErrorMessage(err)}${c.reset}`);
    console.error(
      `${c.dim}Fallback: npx cfm-sdk fill-implementation-plan --from-fetch${c.reset}`,
    );
    return 1;
  }
}
